import EmployeeCategoryService from 'src/modules/employeeCategory/employeeCategoryService';
import Errors from 'src/modules/shared/error/errors';
import {getHistory} from 'src/modules/history';

const prefix = 'EMPLOYEE_CATEGORY_VIEW';

const employeeCategoryViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({type: employeeCategoryViewActions.FIND_STARTED});
      const record = await EmployeeCategoryService.find(id);
      dispatch({type: employeeCategoryViewActions.FIND_SUCCESS, payload: record});
    } catch (error) {
      Errors.handle(error);
      dispatch({type: employeeCategoryViewActions.FIND_ERROR});
      getHistory().push('/employee-category');
    }
  },
};

export default employeeCategoryViewActions;
